import { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

import { SalaryAdvanceRootPageDocument } from 'generated/resources/graphql'
import { AvailableModules } from 'generated/featureDefinitions'

import NotFound from 'modules/core/components/NotFound'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'

import { ValidReasons } from 'modules/upsell/hooks/useCreateUpsellRequest'
import { UpsellingKit } from 'modules/upselling_kit/components'
import PageLoading from 'modules/layout/components/Page/Loading'
import CollectionsBootstrap from 'modules/salary_advance/lib/CollectionsBootstrap'

const SalaryAdvanceUpsellModal = () => {
  const [navigateAway, setNavigateAway] = useState(false)
  const { navigation } = useNavigation()

  if (navigateAway) {
    return <Navigate replace to={navigation.compensations.fullPath()} />
  }

  return (
    <UpsellingKit.ProductModal
      moduleRequested={AvailableModules.salary_advance}
      requestReason={ValidReasons.MissingAddon}
      requestSource="salary_advance_tab"
      pageSource="salary_advance_tab"
      isOpen
      onClose={() => setNavigateAway(true)}
    />
  )
}

const Container = () => {
  const { data, loading } = useQuery(SalaryAdvanceRootPageDocument)

  const canSeeSalaryAdvance = data?.salaryAdvance._policies.manageSalaryAdvance.can ?? false
  const canRequestUpsell = data?.upsell?._policies?.canRequestUpsell?.can ?? false

  if (loading) return <PageLoading />

  if (canSeeSalaryAdvance) return <Outlet />

  if (canRequestUpsell) {
    return <SalaryAdvanceUpsellModal />
  }

  return <NotFound />
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
